export interface INotification {
  additionalEmailIds: string[]
  emailBody: string | null
  emailSubject: string | null
  helperText: string
  id: number
  isEnabled: boolean
  notificationEventId: number
  notificationEventName: string
  notificationType: 'Sales Center' | 'Form Manager'
  receiveAgreementOnEverySignature: boolean | null
  salesTeamHierarchy: SalesTeamHierarchy
  maxReminderFollowups: number
  reminderFrequency: number
  reminderFrequencyType: 'Day' | 'Week' | 'Month'
}

export interface INotificationDTO
  extends Omit<INotification, 'salesTeamHierarchy' | 'additionalEmailIds'> {
  additionalEmailIds: string | null
  salesTeamHierarchy: string | null
}

export const notificationDTOToEntity = ({
  additionalEmailIds,
  salesTeamHierarchy,
  ...response
}: INotificationDTO): INotification => ({
  ...response,
  additionalEmailIds:
    additionalEmailIds !== null ? additionalEmailIds.split(',') : [],
  salesTeamHierarchy:
    salesTeamHierarchy !== null
      ? JSON.parse(salesTeamHierarchy)
      : { salesTeamIds: [], salesTeamPositions: [] },
})

export interface INotificationUpdate
  extends Omit<
    INotification,
    | 'helperText'
    | 'notificationEventName'
    | 'notificationType'
    | 'additionalEmailIds'
    | 'salesTeamHierarchy'
  > {
  additionalEmailIds: string | null
  salesTeamHierarchy: string | null
}

export interface SalesTeamHierarchy {
  salesTeamIds: number[]
  salesTeamPositions: NotificationSalesTeamPosition[]
}

export interface NotificationSalesTeamPosition {
  id: number
  isSelected: boolean
  employees: string[]
}
